import { WhatsappLogo } from "@phosphor-icons/react";

const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER;
const PHONE_DISPLAY = process.env.REACT_APP_PHONE_DISPLAY;

export default function Footer() {
  return (
    <footer className="bg-ink text-[#FAFAFA] py-14 noise-overlay" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
        <div>
          <a href="#top" data-testid="footer-logo-link">
            <img
              src="/assets/logo-white.png"
              alt="Kordeiro — Informática, Tecnologia e Segurança"
              data-testid="footer-logo"
              className="h-28 w-auto"
            />
          </a>
          <p className="mt-4 text-sm text-neutral-400 max-w-xs leading-relaxed">
            TI que não para e conexão estável para pequenas e médias empresas.
          </p>
        </div>
        <nav className="flex flex-col sm:flex-row gap-5 sm:gap-10 text-sm" data-testid="footer-links">
          <a href="#servicos" data-testid="footer-link-services" className="text-neutral-400 hover:text-gold transition-colors duration-300">Serviços</a>
          <a href="#diferencial" data-testid="footer-link-differential" className="text-neutral-400 hover:text-gold transition-colors duration-300">Diferencial</a>
          <a href="#depoimentos" data-testid="footer-link-testimonials" className="text-neutral-400 hover:text-gold transition-colors duration-300">Depoimentos</a>
          <a href="#contato" data-testid="footer-link-contact" className="text-neutral-400 hover:text-gold transition-colors duration-300">Contato</a>
          <a
            href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Olá! Gostaria de solicitar um orçamento de TI para minha empresa.")}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-2 text-gold hover:text-gold-light transition-colors duration-300 font-semibold"
          >
            <WhatsappLogo size={16} weight="fill" />
            {PHONE_DISPLAY}
          </a>
        </nav>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-neutral-500">
        <p data-testid="footer-copyright">© 2026 Kordeiro MSP. Todos os direitos reservados.</p>
        <p>Segurança • Continuidade • Organização</p>
      </div>
    </footer>
  );
}
